<template>
  <div class="m-4">
    <div
      class="d-flex flex-row justify-content-between align-items-center mb-3"
    >
      <h5 class="mb-0">Insurance Companies</h5>
      <b-button
        class="pt-2 pb-2"
        size="sm"
        @click="addInsuranceCompany"
        variant="primary"
        >New</b-button
      >
    </div>
    <div class="d-flex flex-row justify-content-end align-items-center mb-3">
      <b-form-group class="text-left mb-0">
        <b-form-input
          size="sm"
          placeholder="Search"
          v-model="search"
        ></b-form-input>
      </b-form-group>
    </div>
    <grid
      :groupFeature="false"
      :columns="columns"
      :autoHeight="true"
      :data="items"
      :columnLines="false"
      :searchFeature="true"
      :stripeFeature="false"
      @storesort="listeners.storeSort"
    ></grid>
    <bottom-paginator
      :total="total"
      :page="paginator.page"
      :perPage="paginator.perPage"
      @change-page="changePage"
    />
    <insurance-company-modal
      v-if="showInsuranceCompanyModal"
      v-model="showInsuranceCompanyModal"
      :formId="formId"
      @onModify="getInsuranceCompanies"
    />
  </div>
</template>

<script>
import Grid from "../../third_party/grid/Grid.vue";
import insuranceCompanyServer from "../../server/insuranceCompany";
import BottomPaginator from "../controls/BottomPaginator.vue";
import InsuranceCompanyModal from "./InsuranceCompanyModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  name: "InsuranceCompanyCrud",
  components: {
    Grid,
    BottomPaginator,
    InsuranceCompanyModal
  },
  data() {
    const self = this;
    return {
      list: [],
      formId: null,
      showInsuranceCompanyModal: false,
      search: "",
      total: 0,
      paginator: {
        page: 0,
        perPage: 10
      },
      orderBy: null,
      orderByDescending: false,
      listeners: {
        storeSort: sortData => {
          if (sortData.sorters.length == 1) {
            const sorter = sortData.sorters[0];
            const ascending = sorter.ascending;
            const field = sorter.field;
            self.orderBy = field;
            self.orderByDescending = !ascending;
            self.changePage(0);
          }
        }
      }
    };
  },
  mounted() {
    this.getInsuranceCompanies();
    this.fetchStates();
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("client", ["fetchStates"]),
    async getInsuranceCompanies() {
      const result = await insuranceCompanyServer.query({
        searchPhrase: this.search,
        page: this.paginator.page,
        pageSize: this.paginator.perPage
      });
      this.list = result.records;
      this.total = result.count;
    },
    addInsuranceCompany() {
      this.formId = null;
      this.showInsuranceCompanyModal = true;
    },
    changePage(page) {
      this.paginator.page = page;
      this.getInsuranceCompanies();
    }
  },
  computed: {
    ...mapState("client", {
      states: state =>
        state.states.map(s => ({
          label: s.name,
          value: s.id
        }))
    }),
    items() {
      return this.list.map(item => ({
        ...item
      }));
    },
    columns() {
      let columns = [
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Payer ID",
          field: "payerId",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 110,
          actions: [
            {
              tooltip: "Edit",
              renderer: () =>
                `<img class="b-action-item" src=	"${
                  this.isStandalone()
                    ? `/icons/edit.svg`
                    : `/desktop/icons/edit.svg`
                }">`,
              onClick: async ({ record }) => {
                this.formId = record.id;
                this.showInsuranceCompanyModal = true;
              }
            },
            {
              tooltip: "Delete",
              renderer: () =>
                `<img class="b-action-item ml-2 mr-1" src="${
                  this.isStandalone()
                    ? `/icons/delete.svg`
                    : `/desktop/icons/delete.svg`
                }">`,
              onClick: ({ record }) => {
                this.$dialog
                  .confirm(
                    {
                      title: "Are you sure you want to delete this record?"
                    },
                    {
                      view: "confirm-delete"
                    }
                  )
                  .then(async () => {
                    await insuranceCompanyServer.delete(record.id);
                    this.getInsuranceCompanies();
                    this.showAlertSuccess();
                  })
                  .catch(function() {});
              }
            }
          ]
        }
      ];
      return columns;
    }
  },
  watch: {
    search: function() {
      this.paginator = {
        page: 0,
        perPage: 10
      };
      this.getInsuranceCompanies();
    }
  }
};
</script>

<style scoped>
.section-title {
  margin-top: 25px;
  margin-bottom: 15px;
}
.section-body {
  min-height: 70px;
}
</style>
